import { render, staticRenderFns } from "./SportsDefaultFooter.vue?vue&type=template&id=e829449c&scoped=true"
import script from "./SportsDefaultFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsDefaultFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsDefaultFooter.vue?vue&type=style&index=0&id=e829449c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e829449c",
  null
  
)

export default component.exports